import { FC } from 'react';

import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { PREVIOUS_RESPONSE_ROW_TEST_IDS } from '@/constants/data-testids';

import { TableCell, TableRow } from '../Table/Table';

export const PreviousResponseRowSkeleton: FC = () => {
  return (
    <TableRow data-testid={PREVIOUS_RESPONSE_ROW_TEST_IDS.SKELETON}>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
      <TableCell>
        <Skeleton className="h-[14px] w-full" />
      </TableCell>
    </TableRow>
  );
};
